import styled from "styled-components";
import { H3 } from "../../../../common";

export const SText = styled(H3).attrs({ as: "span" })`
  font-size: ${({ theme }) => theme.fontSize.base};
`;
